<template>
  <p
    class="border-situational-lightgrey flex w-max flex-col space-y-1 rounded-t-2xl rounded-bl-2xl rounded-br-[4px] border px-3 py-2"
  >
    <span class="text-text-neutral-primary break-words">{{
      message.content.text
    }}</span>
    <span class="flex justify-end">
      <span class="text-situational-darkgrey text-[11px]">{{
        formattedDate
      }}</span>
    </span>
  </p>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { dateUtils } from 'shared';

  import { type AiChatMessage } from '../../api';

  const props = defineProps<{
    message: AiChatMessage;
  }>();

  const formattedDate = computed(() => {
    if (!props.message.created_at) {
      return '';
    }
    if (props.message.created_at instanceof Date) {
      return dateUtils.prettyTime(props.message.created_at);
    }
    return dateUtils.prettyTime(new Date(props.message.created_at));
  });
</script>
